let __nuid = 0;
const _uid = () => `n-${Date.now()}-${++__nuid}`;

export function NeighborsSection({ de, editing, form, setForm, selected }) {
  const items = form?.neighbors || [];
  const update = (i, patch) => {
    const list = [...items];
    list[i] = { ...list[i], ...patch };
    setForm({ ...form, neighbors: list });
  };
  const remove = (i) => setForm({ ...form, neighbors: items.filter((_, idx) => idx !== i) });
  const add = () => setForm({ ...form, neighbors: [...items, { name: "", address_hint: "", doorbell_name: "", phone: "", note: "", _uid: _uid() }] });

  return (
    <section className="bg-white border border-navy/10 p-6 md:p-8 lg:col-span-2" data-testid="handbook-neighbors">
      <div className="label-caps mb-4">{de ? "Nachbarn" : "Neighbours"}</div>
      {editing ? (
        <div className="space-y-3">
          {items.map((n, i) => (
            <div key={n._uid || i} className="grid grid-cols-1 md:grid-cols-12 gap-2" data-testid={`neighbor-row-${i}`}>
              <input placeholder={de ? "Name (z. B. Familie Lundgren)" : "Name (e.g. Lundgren family)"} value={n.name}
                onChange={(e) => update(i, { name: e.target.value })}
                className="md:col-span-3 bg-white border border-navy/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]" />
              <input placeholder={de ? "Adresse (z. B. Nr. 14)" : "Address (e.g. #14)"} value={n.address_hint || ""}
                onChange={(e) => update(i, { address_hint: e.target.value })}
                className="md:col-span-2 bg-white border border-navy/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]" />
              <input placeholder={de ? "Klingelname" : "Doorbell name"} value={n.doorbell_name || ""}
                onChange={(e) => update(i, { doorbell_name: e.target.value })}
                className="md:col-span-2 bg-white border border-navy/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]" />
              <input placeholder={de ? "Telefon (optional)" : "Phone (optional)"} value={n.phone || ""}
                onChange={(e) => update(i, { phone: e.target.value })}
                className="md:col-span-2 bg-white border border-navy/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]" />
              <input placeholder={de ? "Notiz" : "Note"} value={n.note || ""}
                onChange={(e) => update(i, { note: e.target.value })}
                className="md:col-span-2 bg-white border border-navy/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]" />
              <button type="button" onClick={() => remove(i)}
                className="md:col-span-1 border border-navy/20 text-navy text-[11px] tracking-widest uppercase hover:border-red-800 hover:text-red-800 transition-colors">
                ×
              </button>
            </div>
          ))}
          <button type="button" data-testid="handbook-add-neighbor-btn" onClick={add}
            className="border border-navy text-navy px-4 py-2 text-[12px] tracking-widest uppercase hover:bg-navy hover:text-ivory transition-colors">
            + {de ? "Nachbar hinzufügen" : "Add neighbour"}
          </button>
        </div>
      ) : (selected.neighbors || []).length === 0 ? (
        <div className="text-[13px] text-navy-dark/50">—</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {(selected.neighbors || []).map((n, i) => (
            <div key={n.name ? `${n.name}-${i}` : i} className="border-l-2 border-gold pl-4 py-1" data-testid={`neighbor-card-${i}`}>
              <div className="font-display text-xl text-navy leading-tight">{n.name}</div>
              {(n.address_hint || n.doorbell_name) && (
                <div className="text-[12px] text-navy-dark/70 mt-1">
                  {n.address_hint}
                  {n.address_hint && n.doorbell_name && " · "}
                  {n.doorbell_name && <span className="italic">{de ? "Klingel: " : "Bell: "}{n.doorbell_name}</span>}
                </div>
              )}
              {n.phone && (
                <a href={`tel:${n.phone}`} className="text-[13px] text-navy hover:text-gold border-b border-gold/40 mt-2 inline-block transition-colors">
                  {n.phone}
                </a>
              )}
              {n.note && (
                <div className="text-[13px] text-navy-dark/80 mt-2 leading-relaxed italic">"{n.note}"</div>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
